// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgPopsicle = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id="Vrstva_1"
    data-name="Vrstva 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="287 181 220 220"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.po-1 {
  fill: #9b6c00;
}

.po-2 {
  stroke: #fff;
  stroke-width: 0.25px;
}

.po-2,
.po-3,
.po-4,
.po-5 {
  stroke-miterlimit: 10;
}

.po-6,
.po-4 {
  fill: #fff;
}

.po-7 {
  fill: #484747;
}

.po-8 {
  fill: #f39ee5;
}

.po-3,
.po-4 {
  stroke: #000;
  stroke-width: 0.5px;
}

.po-5 {
  fill: none;
  opacity: 0.45;
  stroke: #1d1d1b;
  stroke-width: 0.2px;
}

.po-9 {
  opacity: 0.4;
}

.po-9,
.po-10 {
  fill: var(--mascot-accent, #ff49a4);
}
`}</style>
    </defs>
    <path
      className="po-6"
      d="M502.09,290.34c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.52.35-1.04.69-1.56,1.03-.47.31-.94.61-1.42.9-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-18.95-.77-36.6-6.56-51.68-16.06-.52-.33-1.03-.67-1.54-1-.04-.02-.09-.05-.13-.08-.01,0-.01-.01-.02-.01-.24-.17-.5-.32-.74-.5-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path
      className="po-9"
      d="M502.09,290.34c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.52.35-1.04.69-1.56,1.03-.47.31-.94.61-1.42.9-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-18.95-.77-36.6-6.56-51.68-16.06-.52-.33-1.03-.67-1.54-1-.04-.02-.09-.05-.13-.08-.01,0-.01-.01-.02-.01-.24-.17-.5-.32-.74-.5-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path d="M473.02,337.61c.58-1.87-6.72-11.01-11.79-17.2-5.07-6.17-10.5-12.96-15.99-18.27-2.25-2.18-5.52-5.16-8.57-7.89-.67-.63-1.33-1.22-1.96-1.78-2.12-1.87-3.97-3.51-5.12-4.51-.77-.68-1.21-1.07-1.21-1.07,0,0-1.39,12.3-.7,17.76.02.17.04.32.07.48.75,5.43,2.93,12.67,7.03,17.6.71.85,1.43,1.62,2.2,2.35.45.43.92.87,1.4,1.27.44.39.96.78,1.5,1.2.7.56,1.41,1.07,2.13,1.6.11.06.22.15.32.24.29.2.55.4.84.61,1.59,1.11,3.2,2.25,4.83,3.57.24.18.47.37.7.56.28.24.53.45.78.67,5.25,4.55,12.65,11.72,14.57,11.04,1.93-.69,8.4-6.33,8.97-8.22Z" />
    <path d="M349.4,333.06c.3-.2.58-.42.88-.62.1-.1.22-.19.33-.25.74-.55,1.47-1.1,2.2-1.66.56-.43,1.1-.84,1.56-1.24.49-.42.97-.87,1.45-1.32.8-.75,1.53-1.56,2.27-2.43,4.25-5.1,6.51-12.61,7.27-18.23.04-.16.06-.32.09-.49.71-5.65-.74-18.39-.74-18.39,0,0-.45.4-1.24,1.11-1.2,1.04-3.11,2.73-5.31,4.67-.65.59-1.33,1.2-2.02,1.85-3.07,2.73-6.33,5.7-8.65,7.95-.04-.01-.07-.04-.1-.07-.3-.22-.58-.42-.88-.64-1.63-1.16-3.31-2.33-5-3.69-.25-.19-.48-.38-.72-.58-.27-.25-.53-.46-.8-.69-5.44-4.71-13.1-12.13-15.08-11.42-2,.71-8.7,6.55-9.28,8.5-.61,1.94,6.95,11.41,12.2,17.81,5.03,6.13,10.42,12.88,15.89,18.28l5.68,1.55Z" />
    <path
      className="po-6"
      d="M453.77,378.97c-.47.31-.94.61-1.42.9-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-18.95-.77-36.6-6.56-51.68-16.06-1.59-8.32-1.72-17.21.04-26.38,1.4-7.27,3.06-14.39,5.01-21.21.58-2.01,1.18-4,1.81-5.95.03-.12.07-.24.11-.36,4.44-13.78,10.16-26.02,17.41-35.24.36-.47.74-.94,1.12-1.39,8.34-10.03,18.61-16.12,31.15-16.17h.15c12.26,0,22.54,5.55,30.92,14.95.33.36.66.73.98,1.11,7.69,9.02,13.74,21.33,18.22,35.54,1.15,3.64,2.2,7.4,3.14,11.26,1.38,5.63,2.55,11.47,3.5,17.46,1.43,8.95,1.2,17.62-.34,25.74Z"
    />
    <path
      className="po-3"
      d="M447.16,324.51c-8.91,18.22-28.08,30.81-50.28,30.81s-40.53-12.05-49.67-29.61c9.68-30.09,25.5-52.8,49.83-52.8s40.62,21.57,50.12,51.6Z"
    />
    <path
      className="po-2"
      d="M432.49,280.76s.07-.01.07-.01c-4.79,15.1-15.09,24.95-18.34,35.77-4.34,14.42-5.66,29.25-6.89,30.59-2.47,2.65-17.27,2.65-20.55,0-1.65-1.34-1.15-15.41-6.06-28.22-5.59-14.51-6.38-16.68-13.56-27.81.01-.03.03-.07.07-.1-4.34-6.62-10.45-18.91-10.45-30.1,0-25.02,17.87-45.3,39.88-45.3s39.88,20.28,39.88,45.3c0,7.14-1.45,13.88-4.05,19.88Z"
    />
    <g>
      <path
        className="po-8"
        d="M366.49,275.5c1.29-.53,2.15-1.06,2.67-2.34.52-1.28.26-2.26-.29-3.53-.56-1.27-1.93-2.44-3.11-2.95-1.18-.51-2-.69-3.26-.46-1.26.23-3.23,1.48-3.71,2.77-.47,1.3-.26,2.26.29,3.53.56,1.27,1.55,2.33,3.11,2.95,1.56.62,3.01.55,4.3.02Z"
      />
      <path
        className="po-8"
        d="M426.57,275.45c-1.3-.5-2.17-1.01-2.72-2.28-.54-1.27-.31-2.25.22-3.53.53-1.28,1.88-2.48,3.05-3.01,1.17-.53,1.98-.73,3.25-.52,1.27.2,3.26,1.41,3.76,2.7.5,1.29.31,2.25-.22,3.53-.53,1.28-1.51,2.36-3.05,3.01-1.55.65-3,.61-4.3.11Z"
      />
    </g>
    <path
      className="po-7"
      d="M374.18,224.43c-3.99,3.28-7.75,7.32-10.43,12.03-3.49-1.68-7.1-3.98-7.62-6.41-.95-4.48.99-9.16,3.83-11.08,2.84-1.91,5.36-2,8.69-1.15,1.62.41,3.77,3.53,5.53,6.61Z"
    />
    <path
      className="po-7"
      d="M437.52,230.05c-.52,2.43-4.62,4.74-8.11,6.41-2.68-4.71-5.78-7.89-9.78-11.17,1.76-3.07,3.75-7.06,5.37-7.46,3.32-.85,5.85-.77,8.69,1.15,2.84,1.91,4.78,6.59,3.83,11.08Z"
    />
    <path
      className="po-4"
      d="M372.11,254.68c.08-5.36-4.2-9.77-9.58-9.85-5.37-.08-9.8,4.19-9.88,9.55-.08,5.36,4.2,9.77,9.58,9.85,5.37.08,9.8-4.19,9.88-9.55Z"
    />
    <path d="M363.31,262.66c4.39.68,8.12-3.03,7.45-7.41-.42-2.72-2.65-4.94-5.37-5.36-4.39-.68-8.12,3.03-7.45,7.41.42,2.72,2.65,4.94,5.37,5.36Z" />
    <path
      className="po-4"
      d="M440.25,254.68c.08-5.36-4.2-9.77-9.58-9.85-5.37-.08-9.8,4.19-9.88,9.55-.08,5.36,4.2,9.77,9.58,9.85,5.38.08,9.8-4.19,9.89-9.55Z"
    />
    <path d="M427.5,262.31c4.39.68,8.12-3.04,7.45-7.41-.42-2.72-2.65-4.94-5.37-5.36-4.39-.68-8.12,3.04-7.45,7.41.42,2.72,2.65,4.94,5.37,5.36Z" />
    <rect
      className="po-1"
      x={323.94}
      y={281.56}
      width={4.26}
      height={16.86}
      rx={1.28}
      ry={1.28}
      transform="translate(82.08 -71.79) rotate(14.36)"
    />
    <path
      className="po-10"
      d="M341.54,265.71l-5.66,22.1c-.31,1.22-1.55,1.95-2.77,1.64l-12.95-3.31c-1.22-.31-1.95-1.55-1.64-2.77l5.66-22.1c1.23-4.79,6.11-7.68,10.9-6.46.14.04.29.08.43.12-.91,1.11-1.23,2.34-.7,3.19.25.41.67.68,1.18.81-.7,1.01-.9,2.07-.42,2.83.49.79,1.59,1.07,2.86.84-.15.59-.11,1.14.17,1.59.52.84,1.73,1.1,3.1.8-.04.24-.09.48-.15.72Z"
    />
    <rect
      className="po-5"
      x={325.26}
      y={264.74}
      width={2.62}
      height={18.89}
      rx={0.78}
      ry={0.78}
      transform="translate(78.18 -72.41) rotate(14.36)"
    />
    <rect
      className="po-5"
      x={331.97}
      y={266.26}
      width={2.62}
      height={18.89}
      rx={0.78}
      ry={0.78}
      transform="translate(78.77 -74.03) rotate(14.36)"
    />
    <ellipse
      cx={328.1}
      cy={295.41}
      rx={2.95}
      ry={4.88}
      transform="translate(-103.66 387.62) rotate(-54.05)"
    />
  </svg>
);
export { SvgPopsicle };
